import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import getWindowScrollLeft from "./getWindowScrollLeft";

export default function absolutePosition(
  element: HTMLElement,
  target: HTMLElement,
  isVisible = true,
  position: "center" | "normal" = "normal"
): void {
  if (element) {
    const targetOffset = target.getBoundingClientRect();
    const windowScrollLeft = getWindowScrollLeft();
    let left = +element.style.width.replace("px", "");
    const viewportScale = FlagsMedusa.config_default_viewport_scale.getValue()
    const top = Number(element.style.top.replace("px", ""));

    if (position === "center") {
      left =
        targetOffset.left +
        windowScrollLeft +
        targetOffset.width / 2 -
        Number(element.style.width.replace("px", "")) / 2 -
        (viewportScale - 1) * 120;
    } else {
      left =
        targetOffset.left +
        windowScrollLeft -
        targetOffset.width +
        12 * viewportScale;
      element.style.top = top + 12 * viewportScale + "px";
    }

    element.style.left = left + "px";
    if (element.style.transformOrigin.includes("center bottom")) {
      element.style.top = top - (isVisible ? targetOffset.height : 0) + "px";
      element.classList.add("center-bottom");
    } else {
      element.classList.remove("center-bottom");
    }

    element.style.visibility = "visible";
  }
}
